module.exports = __webpack_public_path__ + "img/morningglow@2x.5325f81.webp";